{
  "09fd2948a8dffd21": "Workplace",
  "1509f561f2416598": "Save",
  "15b7a1e2d83541fd": "Record Change-of-Ownership",
  "180951fbef616064": "This removes the recorded new owner and effective date from {{name}}. You can record a new change of ownership later.",
  "19766ed6ccb2f4a3": "Cancel",
  "1cf8bc7ff36fdae7": "New owner",
  "1d94141ca61f4cfb": "New Facility",
  "2abe42b8023a7cd7": "Record change of ownership",
  "2c3e315dca1ab8e7": "Failed to remove the change of ownership. Please try again or contact support.",
  "4895f73177ab5d67": "Not set",
  "6031ee797185af1e": "Start typing workplace name...",
  "7753397c2f7de806": "Failed to save the change of ownership. Please try again or contact support.",
  "819fd46786737578": "Update change of ownership",
  "8328c521afbe2b1d": "Remove change of ownership?",
  "8c3339684176b8f0": "New owner workplace",
  "a4068889867e0d25": "Effective date",
  "c1c1009d3f37ec05": "Update",
  "c3812fc4acb861d5": "Remove",
  "cc2111dd92b635db": "Searching workplaces...",
  "cd63c7df0fec232f": "Invalid date",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ecce85ce8e6acc28": "Remove change of ownership",
  "efb1b9fb7d251ac7": "Address unavailable"
}
